import axios from "axios";


const API_URL = process.env.REACT_APP_API_URL + '/api/v1/login/';
//const crypto = require("crypto");

class AuthService {
  login(username: string, password: string) {
    return axios
      .post(API_URL, {
        login: username,
        pass: password
      })
      .then(response => {  
            axios
            .get(process.env.REACT_APP_API_URL + '/api/v1/permissao/list/' + response.data[0]["IdGrupoUsuario"])
            .then(responsePer => { 
                  localStorage.setItem("permissoes", JSON.stringify(responsePer.data));
            })           
            
            localStorage.setItem("user", JSON.stringify(response.data));
            return response;
      });
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("auth");
    localStorage.removeItem("permissoes");
    localStorage.clear();
  }

  getCurrentUser() {
    const userStr = localStorage.getItem("user");
    
    if (userStr) {
      axios
      .get(process.env.REACT_APP_API_URL + '/api/v1/permissao/list/' + JSON.parse(userStr)[0]["IdGrupoUsuario"])
      .then(responsePer => { 
            localStorage.setItem("permissoes", JSON.stringify(responsePer.data));
      })
      return JSON.parse(userStr);
    }
    return null;
  }
}

export default new AuthService();